import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'sym-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  endPoint = environment.api.quicksight_cmis;
  imageSrc = '../assets/logos/letha.png';
  user: any;
  userName: any;
  userId: any;
  url = 'https://dev-cmis.auth.eu-west-1.amazoncognito.com/login?client_id=41ak98t3n69adoalv3k2jmrrfc&response_type=token&scope=openid&redirect_uri=https://dev.analytics.cmis.letha-local.co.za/dashboard'
  constructor() {
    this.navigateToTestBed()
  }

  displayErrorState(status: string) {
    console.log(status + '  ERROR');
  }
  displayErrorMessage(status: string) {
    console.log(status + '  ERROR');
  }

  navigateToTestBed() {
    document.location.href = this.url;
  }

}
